import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import logo from "assets/images/logo.png"
import { Link } from "react-router-dom"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              DE{" "}
              <img
                src={logo}
                alt=""
                // className="light-logo"
                height="27"
              />
              {/* <img src={logo} alt="" height="22" /> */}
            </span>
            <span className="logo-lg">
              DE{" "}
              <img
                src={logo}
                alt=""
                // className="light-logo"
                height="27"
              />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm light-logo text-light fs-3">
              <img src={logo} alt="home" className="light-logo" height="27" />
            </span>
            <span className="logo-lg light-logo text-light fs-5">
              <img
                src={logo}
                alt="home"
                className="light-logo pe-2"
                height="27"
              />
              Discover Equestrian
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {},
)(withRouter(withTranslation()(Sidebar)))
